import { PointAvailability } from '@/models/point-feature'
import { ApiClient } from './client'

export class PointFeatureIsEnabledService {
  static create(): PointFeatureIsEnabledService {
    return new PointFeatureIsEnabledService(ApiClient)
  }

  private constructor(private readonly apiClient: typeof ApiClient) {}

  async isEnabled(): Promise<PointAvailability> {
    const res = await this.apiClient.get('/api/common/point/isenabled')

    return convert(res.body.data)
  }
}

const convert = (raw: any): PointAvailability => {
  return {
    on: raw.enabled,
  }
}
